import { Mutation } from 'vuex';
import { IModuleState } from './types';
import { setStorage } from '@/utils/storage';

// 当前组织下的数字资产列表
export const setDigitalAssets: Mutation<IModuleState> = (state, payload) => {
  state.pageList.data = payload.data;
  state.pageList.pageNum = payload.pageNum;
  state.pageList.pageSize = payload.pageSize;
  state.pageList.total = payload.total;
  state.pageList.loading = !!payload.loading;
};

// 数字资产详情
export const setDigitalAssetDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 待导出的文件列表
export const setExportFiles: Mutation<IModuleState> = (state, payload) => {
  state.exportedFiles.data = payload.data;
  state.exportedFiles.loading = !!payload.loading;
};

// 导出任务明细
export const setExportTaskInfo: Mutation<IModuleState> = (state, payload) => {
  state.exportTaskInfo.id = payload.id;
  state.exportTaskInfo.status = payload.status;
  state.exportTaskInfo.progress = payload.progress;
  state.exportTaskInfo.viewUrl = payload.viewUrl;
};

// 任务状态列表
export const setTaskStatuses: Mutation<IModuleState> = (state, payload) => {
  state.taskStatuses.data = payload.data;
  state.taskStatuses.loading = !!payload.loading;
};

// dialog 弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.data = payload.data;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

// 搜索条件是否校验错误
export const setValidError: Mutation<IModuleState> = (state, payload) => {
  state.validError = payload;
};

// 资产附件列表
export const setFileList: Mutation<IModuleState> = (state, payload) => {
  state.fileList = payload || [];
  setStorage('digital-asset-export-list', state.fileList);
};
